import type { AirgapAPI, TrackingConsentDetails } from '@transcend-io/airgap.js-types';
import { MouseEvent } from 'react';
import { ConsentOptions } from '@transcend-io/airgap.js-types/build/core';

/**
 * Accept all tracking purposes.
 *
 * @param airgapApi An instance of the AirgapAPI.
 * @param event The AirgapAuth event.
 */
export const acceptAll = async (
    airgapApi: AirgapAPI,
    event: MouseEvent<HTMLButtonElement>
): Promise<[boolean, TrackingConsentDetails]> => {
    const newConsent: TrackingConsentDetails = airgapApi.getConsent();
    Object.keys(newConsent.purposes).forEach((purpose: string) => {
        newConsent.purposes[purpose] = true;
    });
    const consentOptions = {
        confirmed: true,
        prompted: true,
        timestamp: new Date().toISOString(),
        waitForSync: true,
    } as ConsentOptions;
    const setConsentResult = await airgapApi.setConsent(event.nativeEvent, newConsent.purposes, consentOptions);
    return Promise.resolve([ setConsentResult, newConsent ]);
};
